import { WarrantyRptService } from '../services';
import { WarrantyRptConstants } from '../constants';
import {alertActions} from '.';

export const WarrantyRptActions = {
    getAll,
    loadingData,
    exportData
};

function getAll(obj)
{
    return dispatch =>{
        dispatch(request());
        WarrantyRptService.fetchWarrantyData(obj).then(response => {
            dispatch(loadingData(false));
            dispatch(success(response.ResponseData))

            var data = response.ResponseData;
            if (data != null) {
                data.forEach(function (v) { delete v.TotalRows });
            }
            dispatch(successExport(data))
        },
        error => {
            dispatch(failure(error.toString()));
            dispatch(alertActions.error(error.toString()));
        }
        
        );
    };
    function request() { return { type : WarrantyRptConstants.GETALL_REQUEST } }
    function success(datas) { return { type: WarrantyRptConstants.GETALL_SUCCESS, datas } }
    function successExport(datas) { return { type: WarrantyRptConstants.GETEXPORT_SUCCESS, datas } }
    function failure(error) { return { type: WarrantyRptConstants.GETALL_FAILURE, error } }
}

function exportData(obj) {
    return dispatch => {
        dispatch(request());
        WarrantyRptService.fetchWarrantyData(obj).then(response => {
            dispatch(loadingData(false));
            var data = response.ResponseData;
            if (data != null) {
                data.forEach(function (v) { delete v.TotalRows });
            }
            dispatch(success(data))
        },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            });
    };
    function request() { return { type: WarrantyRptConstants.GETEXPORT_REQUEST } }
    function success(datas) { return { type: WarrantyRptConstants.GETEXPORT_SUCCESS, datas } }
    function failure(error) { return { type: WarrantyRptConstants.GETEXPORT_FAILURE, error } }
}

function loadingData(isbool) {
    return {
        type: WarrantyRptConstants.LOADING_REQUEST, isbool
    }
}
